import { 
  blockchainToChainId, 
  chainIdBrowserEnMap, 
  chainIdBrowserTokenEnMap, 
  chainIdBrowserMap,
  chainIdBrowserTokenMap 
} from "../utils"; 

export default {
  methods: {
    onBlockchainBrowser(address, chain_id, blockchain_id, isToken) {
      // console.log('address', address);
      // console.log('chain_id', chain_id);
      // console.log('blockchain_id', blockchain_id);
      // console.log('isToken', isToken);
      if (chain_id) {
        if (isToken) {
          window.location.href = this.getUrlById(chain_id, 0, address);
        } else {
          window.location.href = this.getUrlById(chain_id, 1, address);
        }
      } else if (!chain_id && blockchain_id) {
        const chainId = blockchainToChainId[blockchain_id];
        if (isToken) {
          window.location.href = this.getUrlById(chainId, 0, address);
        } else {
          window.location.href = this.getUrlById(chainId, 1, address);
        }
      }
    },
    getUrlById(id, type, address) {
      // https://solscan.io/account/3QRP3gihMg2CtLTXWU3yrcPRSr5HJfo2aFjGqNVC3vV2
      // https://solscan.io/token/So11111111111111111111111111111111111111112
      // debugger;
      let url = '';
      if (type === 0) {
        if (this.$i18n.locale === 'zh') {
          url =
            chainIdBrowserTokenMap[id] +
            address +
            (id == '1' ? '?hmsr=tpwallet' : '');
        } else {
          url = chainIdBrowserTokenEnMap[id] + address;
        }
        if (this.isSol) {
          url = `https://solscan.io/token/${address}`;
        }
      } else if (type === 1) {
        if (this.$i18n.locale === 'zh') {
          url =
            chainIdBrowserMap[id] +
            address +
            (id == '1' ? '?hmsr=tpwallet' : '');
        } else {
          url = chainIdBrowserEnMap[id] + address;
        }
        if (this.isSol) {
          url = `https://solscan.io/account/${address}`;
        }
      }
      return url;
    },
  },
};
